<template>
    <b-tabs
        class="apprentice-pills-tab tools-tab"
        v-model="activeTab"
        pills
        vertical
        ref="portfolio-show-tools"
        nav-wrapper-class="col-12 col-lg-3 col-xl-2 d-none d-lg-block tools-tab-wrapper"
        content-class="col-12 col-lg-9 col-xl-10 tools-tab-content"
        @input="updateTabIndex">
        <div class="tools-sub-item-nav d-flex d-lg-none">
            <b-form-select
                class="apprentice-primary-select"
                v-model="activeTab"
                :options="options">
            </b-form-select>

            <div
                class="rating-list d-flex d-lg-none"
                v-if="isRatingSelected">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="selectedRatingLink"
                    :options="ratingsList"
                    @change="updateSelectedRatingLink">
                </b-form-select>
            </div>
        </div>

        <b-tab
            :title="agendaTitle"
            title-item-class="agenda-tab-item"
            title-link-class="settings-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-calendar-alt fa-fw"></i>{{ agendaTitle }}</div>
                </div>
            </template>

            <design-2021-portfolio-show-calendar-component
                :project-in="projectIn"
                :agenda-items="agendaItems"
                :is-teacher="isTeacher"
                :project-id="projectIn.id"
                :is-student="isStudent"
                project-type="project">
            </design-2021-portfolio-show-calendar-component>
        </b-tab>

        <b-tab
            v-if="groupIn.logbook"
            :title="$t('portfolio.logbook')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link nav-link-with-info-badge">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fa fa-clock fa-fw"></i
                        >{{
                            groupIn.logbook_name && groupIn.logbook_name.length > 0
                                ? groupIn.logbook_name
                                : $t('portfolio.logbook')
                        }}
                    </div>
                    <div
                        class="informational"
                        v-if="loggedTotalTime !== '' && loggedTotalTime">
                        <i
                            class="fa-fw fad fa-hourglass-half icon"
                            id="logbook-popover"></i>
                        <b-popover
                            target="logbook-popover"
                            triggers="hover"
                            placement="top"
                            variant="primary">
                            <template #title>{{ $t('portfolio.total_logbook_hours') }}</template>
                            {{ loggedTotalTime }}
                        </b-popover>
                    </div>
                </div>
            </template>
            <div class="logbook-wrapper">
                <design-2021-project-show-logbook-component
                    :project-in="projectIn"
                    :logs-in="logsIn"
                    :logs-by-time-in="logsByTimeIn"
                    :is-teacher="isTeacher">
                </design-2021-project-show-logbook-component>
            </div>
        </b-tab>

        <b-tab
            v-if="groupIn.sourcelist"
            :title="$t('portfolio.sources')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link nav-link-with-info-badge">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-search fa-fw"></i
                        >{{
                            groupIn.sourcelist_name && groupIn.sourcelist_name.length > 0
                                ? groupIn.sourcelist_name
                                : $t('portfolio.source_list')
                        }}
                    </div>
                    <div
                        class="informational"
                        v-if="sourceListCount > 0">
                        <i
                            class="fa-fw fad fa-books icon"
                            id="sources-popover"></i>

                        <b-popover
                            target="sources-popover"
                            triggers="hover"
                            placement="top"
                            variant="primary">
                            <template #title>{{ $t('portfolio.total_source_lists') }}</template>
                            <span>Er zijn </span>{{ sourceListCount }}<span> literatuurlijst(en) toegevoegd.</span>
                        </b-popover>
                    </div>
                </div>
            </template>

            <div>
                <design-2021-project-show-source-component
                    :project-id="projectIn.id"
                    :source-list-data-in="sourceListData"></design-2021-project-show-source-component>
            </div>
        </b-tab>

        <b-tab
            v-if="groupIn.files"
            :title="$t('portfolio.files')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fa-fw fas fa-file-alt fa-fw"></i
                        >{{
                            groupIn.files_name && groupIn.files_name.length > 0
                                ? groupIn.files_name
                                : $t('portfolio.files')
                        }}
                    </div>
                </div>
            </template>

            <design-2021-project-show-files-component :project-id="projectIn.id">
            </design-2021-project-show-files-component>
        </b-tab>

        <b-tab
            v-if="ratings && ratings.length > 0"
            :title="$t('portfolio.assessment')"
            title-item-class="rating-tab-item"
            title-link-class="settings-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <b-card-group
                            class="rating-nav"
                            deck>
                            <b-card
                                class="remove-box-shadow"
                                :header="$t('portfolio.assessments')"
                                header-class="rating-nav-header"
                                body-class="rating-nav-body">
                                <template
                                    v-slot:header
                                    @click="showRating(0)">
                                    <i class="fas fa-award fa-fw"></i
                                    >{{
                                        groupIn.rating_name && groupIn.rating_name.length > 0
                                            ? groupIn.rating_name
                                            : $t('portfolio.assessments')
                                    }}
                                </template>
                                <b-list-group>
                                    <b-list-group-item
                                        class="rating-nav-list-item"
                                        v-for="(rating, index) in ratings"
                                        :key="rating.forms[0].id"
                                        @click="showRating(index)"
                                        active-class="active"
                                        :active="activeTab === 4 && rating.pivot.id === selectedRatingLink">
                                        {{ rating.pivot.title ? rating.pivot.title : rating.title }}
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-card-group>
                    </div>
                </div>
            </template>

            <design-2021-rating-tab-component
                v-if="selectedRating"
                :project-id="projectIn.id"
                :project="projectIn"
                :users-in="users"
                :rating-in="selectedRating">
            </design-2021-rating-tab-component>
        </b-tab>

        <b-tab
            :title="$t('portfolio.participants')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-user fa-fw"></i>{{ $t('portfolio.participants') }}</div>
                </div>
            </template>

            <design-2021-project-show-participator-component :project-in="projectIn">
            </design-2021-project-show-participator-component>
        </b-tab>

        <b-tab
            v-if="groupIn.group_pair_options && groupIn.group_pair_options.course_student_link"
            :title="$t('portfolio.courses')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-book fa-fw"></i>{{ $t('portfolio.courses') }}</div>
                </div>
            </template>

            <design-2021-project-courses-component :project-in="projectIn"></design-2021-project-courses-component>
        </b-tab>

        <b-tab
            v-if="groupIn.magazine"
            title="Magazines"
            title-item-class="tools-tab-item"
            title-link-class="tools-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <b-button
                            class="btn-link-type btn-magazine"
                            variant="primary"
                            @click.prevent.stop="getMagazineUrl">
                            <i class="fas fa-book-open fa-fw"></i>Magazines
                        </b-button>
                    </div>
                </div>
            </template>
        </b-tab>
    </b-tabs>
</template>

<script>
import { CommonBus, SourceBus } from '../../../../app';

export default {
    name: 'design-2021-portfolio-show-tools-component',

    props: {
        projectIn: Object,
        groupIn: Object,
        logsIn: Array,
        logsByTimeIn: Array,
        isTeacher: Boolean,
        questionnaire: Array,
        ratings: Array,
        agendaItems: Array,
        agendaTitle: String,
        isStudent: Boolean,
        coursesIn: Array,
    },

    data() {
        return {
            activeTab: 0,
            sourceListCount: 0,
            sourceListData: [],
            loggedItems: [],
            selectedRating: null,
            selectedRatingLink: null,
            options: [],
            ratingTabIndex: null,
        };
    },

    methods: {
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.portfolioToolsTab = tabIndex;

            if (
                tabIndex === this.ratingTabIndex &&
                this.ratings.length &&
                this.selectedRating === null &&
                this.selectedRatingLink === null
            ) {
                this.selectedRating = this.ratings[0];
                this.selectedRatingLink = this.ratings[0].pivot.id;
                localStorage.portfolioSettingsTabSelectedRating = this.selectedRating.pivot.id;
            }
        },

        getMagazineUrl() {
            if (this.projectIn.magazine !== null && this.groupIn.magazine) {
                window.location.href = this.routes.magazineShow(this.projectIn.magazine.id);
            } else if (this.groupIn.magazine) {
                window.location.href = `${this.routes.paperShow(this.projectIn.id)}/extramagazine`;
            }
        },

        showRating(index) {
            if (!this.ratings.length) {
                return;
            }

            this.selectedRating = this.ratings[index];
            this.selectedRatingLink = this.selectedRating.pivot.id;
            localStorage.paperSettingsTabSelectedRating = this.selectedRating.pivot.id;
            this.updateTabIndex(this.ratingTabIndex);
        },

        updateSelectedRatingLink(value) {
            if (value === 0) {
                return;
            }

            this.selectedRating = this.ratings.find((rating) => rating.pivot.id === value);
            this.selectedRatingLink = value;
            localStorage.portfolioSettingsTabSelectedRating = this.selectedRating.pivot.id;
        },
    },

    computed: {
        loggedTotalTime() {
            let time = 0;
            let hours = 0;
            let minutes = 0;

            if (this.loggedItems.length) {
                for (const item of this.loggedItems) {
                    time = time + item.time_spend;
                }

                if (time > 3599) {
                    hours = Math.floor(time / 3600);
                    minutes = time % 3600;
                    minutes = minutes / 60;
                    return minutes === 0 ? `${hours} uur` : `${hours} uur, ${minutes} min`;
                } else if (time > 0) {
                    minutes = time / 60;
                    return `${minutes} min`;
                }
            }
        },

        users() {
            return this.projectIn.users.filter((user) => user.type === 'student');
        },

        ratingsList() {
            if (!this.ratings.length) {
                return [];
            }

            let ratings = this.ratings.map((rating) => {
                return {
                    text: rating.title,
                    value: rating.pivot.id,
                };
            });

            ratings.unshift({ text: this.$t('portfolio.choose_rating'), value: 0 });

            return ratings;
        },

        isRatingSelected() {
            const ratingTitle =
                this.groupIn.rating_name && this.groupIn.rating_name.length > 0
                    ? this.groupIn.rating_name
                    : this.$t('portfolio.assessment');
            return this.activeTab === this.options.findIndex((option) => option.text === ratingTitle);
        },
    },
    mounted() {
        this.sourceListCount = 0;

        this.axios.get('source/fetchAll/' + this.projectIn.id).then(
            (response) => {
                if (response.data) {
                    this.sourceListData = response.data;
                    this.sourceListCount = response.data.data.length;
                }
            },
            (error) => {
                this.alert.ajaxError(error, this.$t('portfolio.error_retrieving_source_list'));
            },
        );

        this.axios.get('/log/fetchUserTime/' + this.projectIn.id).then(
            (response) => {
                if (response.data) {
                    this.loggedItems = response.data.items;
                }
            },
            (error) => {
                this.alert.ajaxError(error, this.$t('portfolio.error_retrieving_logbook_times'));
            },
        );
    },

    created() {
        const optionPositions = [this.agendaTitle];

        if (localStorage.portfolioToolsTab) {
            this.activeTab = parseInt(localStorage.portfolioToolsTab);

            if (localStorage.portfolioSettingsTabSelectedRating) {
                this.selectedRatingLink = parseInt(localStorage.portfolioSettingsTabSelectedRating);
                let check = false;

                for (const rating of this.ratings) {
                    if (rating.pivot.id === this.selectedRatingLink) {
                        this.selectedRating = rating;
                        check = true;
                        break;
                    }
                }

                if (!check) {
                    this.showRating(0);
                }
            } else {
                this.showRating(0);
            }
        } else {
            this.showRating(0);
        }

        CommonBus.$on('update-source-list-count', (count) => {
            this.sourceListCount = count;
        });

        CommonBus.$on('update-logged-time', (loggedTime) => {
            this.loggedItems = loggedTime;
        });

        SourceBus.$on('add-to-source-counter', () => {
            this.sourceListCount++;
        });

        SourceBus.$on('remove-from-source-counter', () => {
            if (this.sourceListCount > 0) {
                this.sourceListCount--;
            }
        });

        if (this.groupIn.logbook) {
            optionPositions.push(this.$t('portfolio.logbook'));
        }

        if (this.groupIn.sourcelist) {
            optionPositions.push(
                this.groupIn.sourcelist_name && this.groupIn.sourcelist_name.length > 0
                    ? this.groupIn.sourcelist_name
                    : this.$t('portfolio.source_list'),
            );
        }

        if (this.groupIn.files) {
            optionPositions.push(
                this.groupIn.files_name && this.groupIn.files_name.length > 0
                    ? this.groupIn.files_name
                    : this.$t('portfolio.files'),
            );
        }

        if (this.questionnaire) {
            optionPositions.push(
                this.groupIn.questionnaire_name && this.groupIn.questionnaire_name.length > 0
                    ? this.groupIn.questionnaire_name
                    : this.$t('portfolio.questionnaire'),
            );
        }

        if (this.ratings && this.ratings.length > 0) {
            optionPositions.push(
                this.groupIn.rating_name && this.groupIn.rating_name.length > 0
                    ? this.groupIn.rating_name
                    : this.$t('portfolio.assessment'),
            );
        }

        optionPositions.push(this.$t('portfolio.questionnaire'));

        if (this.groupIn.magazine) {
            optionPositions.push('Magazines');
        }

        this.options = optionPositions.map((pos, index) => {
            return {
                value: index,
                text: pos,
            };
        });
    },
};
</script>

<style scoped lang="scss">
.btn-magazine {
    padding: 0;
    text-decoration: none;
    color: $info;
    font-size: $base-font-size;

    &:hover {
        color: $primary;
        text-decoration: none;
        font-weight: $font-weight-bold;
    }
}

.tools-sub-item-nav {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    select {
        width: auto;
        border: 1px solid $primary;
        margin-bottom: 0;
    }

    select,
    div {
        flex: 1;
        margin-right: 0;

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.rating-nav-header {
    padding: 0;
}

.settings-tab-item-link.nav-link-with-info-badge {
    .informational {
        padding-left: map-get($grid-gutter-spacing, 'ten');
        border-left: 1px solid $primary;

        i {
            margin-right: 0;
        }
    }
}

::v-deep .apprentice-pills-tab {
    .nav-link {
        .card-deck {
            div.rating-nav-body {
                padding: 0;

                .rating-nav-list-item {
                    padding: 0;
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .tools-sub-item-nav {
        column-gap: map-get($grid-gutter-spacing, 'fifteen');

        select,
        div {
            flex: 0 0 auto;

            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }
}
</style>
